import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import UserAuditLogsContainer from './components/UserAuditLogsContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './UserAuditLogs.css';

const UserAuditLogs = () => (
  <PageContainer pageName="userauditlogs">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_USER_AUDIT_LOGS}>
      <UserAuditLogsContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default UserAuditLogs;
